import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Recycle, Plus, Camera } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { pops, popsPath, num, fmtDate, hasPops } from "../../bespoke/PopsWasteList/popsApi";

/** On a job page: what POPs waste has been recorded for this job, plus "Record waste collected" for the crew. */
export function PopsJobCard({ jobId, user, className = "" }) {
  const [rows, setRows] = useState(null);
  const enabled = hasPops(user);
  useEffect(() => { if (enabled && jobId) pops.collections({ job_id: jobId }).then(setRows).catch(() => setRows([])); }, [enabled, jobId]);
  if (!enabled) return null;
  const items = (rows || []).reduce((s, c) => s + (c.totals?.items || 0), 0);
  const vol = (rows || []).reduce((s, c) => s + (c.totals?.volume_m3 || 0), 0);
  return (
    <div className={`bg-card border border-border rounded-lg p-4 border-l-4 border-l-emerald-600 ${className}`} data-testid="pops-job-card">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="text-sm font-semibold flex items-center gap-2"><Recycle size={18} className="text-emerald-600" /> POPs waste collected</h2>
        <Button size="sm" variant="outline" asChild data-testid="pops-job-record-btn"><Link to={`${popsPath("collections/new")}?job_id=${jobId}`}><Plus size={14} className="mr-1" /> Record waste collected</Link></Button>
      </div>
      {rows === null ? <p className="text-xs text-muted-foreground mt-2">Loading…</p> : !rows.length ? (
        <p className="text-xs text-muted-foreground mt-2" data-testid="pops-job-empty">Nothing recorded for this job yet — tap the items as they go on the van and the office can add them straight to the invoice.</p>
      ) : (
        <>
          <p className="text-xs text-muted-foreground mt-1" data-testid="pops-job-summary">{items} item{items === 1 ? "" : "s"} · {num(vol, 2)} m³ across {rows.length} collection record{rows.length === 1 ? "" : "s"}</p>
          <ul className="mt-2 divide-y divide-border">
            {rows.map((c) => (
              <li key={c.id}><Link to={popsPath(`collections/${c.id}`)} className="flex items-center justify-between gap-2 py-1.5 text-sm hover:text-primary" data-testid={`pops-job-collection-${c.id}`}>
                <span className="truncate">{fmtDate(c.collected_at)} · {c.crew_name} · {(c.items || []).map((r) => `${r.qty}× ${r.name}`).join(", ")}</span>
                <span className="shrink-0 inline-flex items-center gap-2 text-xs text-muted-foreground">{c.photo_count > 0 && <span className="inline-flex items-center gap-0.5"><Camera size={12} /> {c.photo_count}</span>}<span className={`px-1.5 py-0.5 rounded-full text-[10px] ${c.status === "invoiced" ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-400/20 dark:text-emerald-100" : "bg-amber-100 text-amber-800 dark:bg-amber-400/20 dark:text-amber-100"}`}>{c.status === "invoiced" ? "Invoiced" : "Awaiting invoice"}</span></span>
              </Link></li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
